// Environments

const {API_URL, LOGIN_API_URL, APP_ENV, DEPLOY_TAG, DATADOG_OTEL_TOKEN} = process.env;

const MERCHANT_API_URL_DEFAULT = 'https://api.xsolla.com';
const DISPUTES_API_URL_DEFAULT = 'https://afs.xsolla.com/disputes/api/v1';
const FILE_MANAGER_API_URL_DEFAULT = 'https://afs.xsolla.com/partner-file-management';
const SLEMMA_URL_DEFAULT = 'https://analytics.xsolla.com';

const serviceName = 'disputes-publisher-account';
const DATADOG_OTEL_TOKEN_DEFAULT =
  'rtq4XfnW6JX6djgokM7+evwzAMN+b3x3tyPYdb9CyPWeZHR1DPoIAXLVoCKkrBH3ExO4mxEtxeXAEo7ifttGWw==';
const OTEL_COLLECTOR_URL_DEFAULT = 'https://yxbwcm92zwqtdmluy2hha292.xsolla.com';
const defaultApiUrl = {
  'sv-prod': MERCHANT_API_URL_DEFAULT,
  prod: MERCHANT_API_URL_DEFAULT,
  'prod-local': MERCHANT_API_URL_DEFAULT,
  stage: 'https://merchant-api-test.srv.local',
  dev: 'https://merchant-api-test.srv.local'
}[APP_ENV];
const apiUrl = API_URL || defaultApiUrl;

const loginApiUrl = LOGIN_API_URL || 'https://login.xsolla.com';

const slemmaUrl =
  {
    'sv-prod': SLEMMA_URL_DEFAULT,
    prod: SLEMMA_URL_DEFAULT,
    'prod-local': SLEMMA_URL_DEFAULT,
    stage: 'https://x.slemma.com',
    dev: 'http://localhost'
  }[APP_ENV] || FILE_MANAGER_API_URL_DEFAULT;

const disputesApiUrl =
  {
    'sv-prod': 'https://dispute.afs.srv.local/api/v1/',
    prod: 'https://afs.xsolla.com/disputes/api/v1',
    stage: 'https://dispute-service.nl-k8s-stage.srv.local/api/v1/',
    dev: 'http://localhost:7100/api/v1/'
  }[APP_ENV] || DISPUTES_API_URL_DEFAULT;

const fileManagerApiUrl =
  {
    'sv-prod': 'https://afs.xsolla.com/partner-file-management/api/v1/',
    prod: 'https://afs.xsolla.com/partner-file-management/api/v1/',
    stage: 'https://partner-file-management.nl-k8s-stage.srv.local/partner-file-management/api/v1/',
    dev: 'http://localhost:8111/partner-file-management/api/v1/'
  }[APP_ENV] || 'http://localhost:8111/partner-file-management/api/v1/';

const DEFAULT_NGINX_TIMEOUT = 120000;

const NGINX_TIMEOUT = parseInt(process.env.NGINX_TIMEOUT) || DEFAULT_NGINX_TIMEOUT;

const otelCollectorUrl = OTEL_COLLECTOR_URL_DEFAULT;
const otelBearerToken = DATADOG_OTEL_TOKEN || DATADOG_OTEL_TOKEN_DEFAULT;
const otelEnabled = true;

export default {
  app_name: 'publisher-client',
  service_name: serviceName,
  api_url: apiUrl,
  slemma_url: slemmaUrl,
  login_api_url: loginApiUrl,
  env: APP_ENV || 'dev',
  port: process.env.PORT || 9000,
  disputes_api_url: disputesApiUrl,
  file_manager_api_url: fileManagerApiUrl,
  nginxTimeout: NGINX_TIMEOUT,
  releaseVersion: DEPLOY_TAG,
  otel: {
    enabled: otelEnabled,
    serviceName: serviceName,
    collectorUrl: otelCollectorUrl,
    bearerToken: otelBearerToken
  }
};
